:host {
    @include typo-ws-paragraph;

    color: $color-grey-05-light;
    overflow: hidden;

    div {
        display: flex;
        gap: 4px;
        transform: translate3d(-24px, 0, 0);
        transition: transform 0.2s;
    }

    .svg {
        flex-shrink: 0;
        width: 20px;
        margin-top: 2px;
        opacity: 0;
        transition: opacity 0.2s;
    }

    ::slotted(a) {
        color: currentColor;
        text-decoration: none;
    }
}

:host(:hover) {
    div {
        transform: translate3d(-4px, 0, 0);
    }

    .svg {
        opacity: 1;
    }
}
